const en = {
  lang: {
    change: "Change language",
    english: "English - EN",
    hindi: "हिन्दी - HI",
    code: { en: "EN", hi: "HI" },
  },
  nav: {
    products: "Products",
    coverageCalculators: "Coverage Calculators",
    adhesiveCoverage: "Adhesive Coverage",
    groutCoverage: "Grout Coverage",
    groutVisualizer: "Grout Visualizer",
    about: "About",
    careers: "Careers",
    journal: "Journal",
    contact: "Contact",
    getQuote: "Get a Quote",
    catalogue: "Catalogue",
    viewAllProducts: "View all products",
    openMenu: "Open menu",
    closeMenu: "Close menu",
  },
  footer: {
    letsBuild: "Let's build together",
    certifiedQuality: "Certified quality for",
    modernIndia: "modern India.",
    requestQuote: "Request a quotation",
    isoLine: "ISO 9001:2015 · ISI Marked",
    blurb: "Construction chemicals engineered with premium raw materials. Certified quality, innovation and long-term performance in every batch.",
    products: "Products",
    tools: "Tools",
    company: "Company",
    tileAdhesives: "Tile Adhesives",
    grouts: "Grouts",
    admixtures: "Admixtures",
    blockAdhesive: "Block Adhesive",
    plasterFlooring: "Plaster & Flooring",
    adhesiveCalculator: "Adhesive Calculator",
    groutCalculator: "Grout Calculator",
    groutVisualiser: "Grout Visualiser",
    journal: "Journal",
    aboutUs: "About Us",
    careers: "Careers",
    contact: "Contact",
    getQuote: "Get a Quote",
    rights: "Ashlar Buildchem. All rights reserved.",
    tagline: "Construction Chemicals for Modern India",
  },
  home: {
    eyebrow: "Construction Chemicals · Est. 2020 · India",
    heroLine1: "Construction",
    heroLine2a: "Chemicals",
    heroLine2b: " for",
    heroLine3: "Modern India",
    heroBody: "Tile adhesives, grouts and building solutions engineered with certified quality, advanced chemistry and long-term performance.",
    exploreProducts: "Explore Products",
    coverageCalculators: "Coverage Calculators",
    manifesto: "The Manifesto",
    manifestoTitle: "We don't make compromises. We make chemistry.",
    m1Title: "The Foundation",
    m1Body: "Established in 2020, Ashlar Buildchem has become one of India's fastest-growing construction chemical companies — built on certified quality and relentless engineering.",
    m2Title: "The Chemistry",
    m2Body: "Our formulations are engineered with premium raw materials and advanced chemistry — delivering bond strength, flexibility and durability that outperform the ordinary.",
    m3Title: "The Standard",
    m3Body: "ISO 9001:2015 certified processes and ISI-marked products, validated in a state-of-the-art testing facility. Excellence, verified in every single batch.",
    founded: "Founded",
    products: "Products",
    rawMaterials: "Raw materials",
    catalogue: "The Catalogue",
    systemTitle: "A system for every surface.",
    allProducts: "All Products",
    estimator: "Estimator",
    adhesiveCoverage: "Adhesive Coverage",
    adhesiveBody: "Estimate bags of tile adhesive from your area and trowel notch size.",
    groutCoverage: "Grout Coverage",
    groutBody: "Calculate grout consumption from tile geometry and joint width.",
    groutVisualiser: "Grout Visualiser",
    visualiserBody: "Preview tile and grout colour combinations live before you buy.",
    openCalculator: "Open Calculator",
    signature: "Signature Range",
    builtToBond: "Built to bond.",
    readyTitle: "Ready to specify Ashlar?",
    talkTeam: "Talk to our team",
    marqueeAdvanced: "Advanced Chemistry",
    marqueeCertified: "Certified Quality",
    architectureAlt: "Modern architecture",
  },
  about: {
    eyebrow: "Since 2020 · Jaipur, India",
    h1a: "Empowering",
    h1b: "construction with",
    h1c: "certainty.",
    intro: "Established in 2020, Ashlar Buildchem is one of India's fastest-growing construction chemical companies. Our purpose is simple: to empower construction with certified quality, innovation and long-term performance. With ISO-certified processes, ISI-marked products and a state-of-the-art testing facility, we ensure excellence in every batch.",
    standFor: "What we stand for",
    principlesTitle: "Four principles. Zero shortcuts.",
    journey: "The Journey",
    journeyTitle: "Five years, one standard.",
    partner: "Partner with Ashlar.",
    getInTouch: "Get in touch",
    v1Title: "Certified Quality",
    v1Body: "ISO 9001:2015 and ISI standards enforced in every batch.",
    v2Title: "Engineered Chemistry",
    v2Body: "Premium raw materials for real, measurable performance.",
    v3Title: "Long-term Performance",
    v3Body: "Products designed to outlast, not just install.",
    v4Title: "Built for India",
    v4Body: "Formulated for Indian climates, substrates and workmanship.",
    t2020Title: "The Beginning",
    t2020Body: "Ashlar Buildchem is founded in Jaipur with a mission to raise the standard of Indian construction chemicals.",
    t2021Title: "Advanced Chemistry",
    t2021Body: "Formulations upgraded with premium raw materials for superior bond performance.",
    t2022Title: "Certified",
    t2022Body: "ISO 9001:2015 processes and ISI-marked products, validated through a dedicated in-house testing facility.",
    t2025Title: "Nationwide",
    t2025Body: "One of India's fastest-growing construction chemical brands, with a full system across tiling, grouting, blocks and surfaces.",
    labAlt: "Laboratory testing",
    siteAlt: "Construction site",
  },
  contact: {
    eyebrow: "Ashlar Connect",
    h1a: "Let's",
    h1b: "talk.",
    intro: "Request a quote, ask for technical guidance or become a distributor. Fill the form and our specialists will respond.",
    fullName: "Full name *",
    namePlaceholder: "Your name",
    email: "Email *",
    emailPlaceholder: "you@company.com",
    phone: "Phone *",
    company: "Company",
    optional: "Optional",
    subject: "Subject *",
    subjectPlaceholder: "Quote / Distributor / Technical",
    message: "Message *",
    messagePlaceholder: "Tell us about your project…",
    send: "Send Message",
    sending: "Sending…",
    tollFree: "Toll-free",
    emailLabel: "Email",
    office: "Registered office",
    badges: "ISO 9001:2015 · ISI Marked · Certified Quality",
    errRequired: "Please fill in all required fields.",
    errName: "Full name can only contain letters and spaces.",
    errPhone: "Enter a valid 10-digit Indian mobile number.",
    success: "Thank you — our team will reach out shortly.",
    errGeneric: "Something went wrong. Please try again or call 1800 309 0808.",
  },
  products: {
    catalogue: "The Catalogue",
    title: "Products",
    intro: "A complete system of tile adhesives, grouts, admixtures and building solutions — engineered with advanced formulation chemistry.",
    filter: "Filter",
    allProducts: "All Products",
    product: "Product",
    productsCount: "Products",
    explore: "Explore",
  },
  productDetail: {
    loading: "Loading…",
    notFound: "Product not found",
    back: "← Back to products",
    catalogue: "Catalogue",
    requestQuote: "Request a quote",
    coverageCalc: "Coverage calculator",
    overview: "Overview",
    keyFeatures: "Key features",
    technicalData: "Technical data",
    classLabel: "Class",
    enquire: "Enquire / Get a Quote",
    calculate: "Calculate",
    allArrow: "All →",
    features: "Features",
    applications: "Applications",
    substrates: "Substrates",
    packaging: "Packaging",
    coverage: "Coverage",
    colour: "Colour",
    classification: "Classification",
    related: "Related products",
  },
  blog: {
    eyebrow: "Field notes & technical guides",
    title: "Journal",
    readArticle: "Read article",
    loading: "Loading…",
    notFound: "Article not found",
    back: "← Back to journal",
    journal: "Journal",
    similarEyebrow: "Explore More",
    similarTitle: "Similar Articles",
    quickAnswer: "Quick Answer",
    quickAnswerSubtitle: "Key engineering takeaways at a glance",
    faqsTitle: "Frequently Asked Questions",
    faqsSubtitle: "Direct answers to key technical questions from our engineering desk.",
    talkSpecialist: "Talk to a specialist",
    needGuidance: "Need Guidance?",
    consultSpecialists: "Consult our technical specialists",
    guidanceDesc: "Get project-specific recommendations, adhesive specification sheets, and on-site guidance from Ashlar engineers.",
    requestAdvice: "Request Technical Advice",
    tollFreeSupport: "Toll-Free Support",
  },
  calculators: {
    eyebrow: "Estimators & Visualizers",
    h1a: "Estimate &",
    h1b: "Visualise",
    intro: "Estimate exactly how much adhesive or grout your project needs, then visualise your tile and grout colour combination live — before you order.",
    adhesiveTitle: "Adhesive Coverage Calculator",
    groutTitle: "Grout Coverage Calculator",
    totalArea: "Total area to tile",
    bedThickness: "Bed thickness (trowel notch)",
    bedHint: "Larger tiles & uneven surfaces need a thicker bed.",
    bagSize: "Bag size",
    waste: "Add 5% for wastage & spillage",
    estimated: "Estimated requirement",
    bagsRequired: "Bags required",
    bags: "bags",
    totalAdhesive: "Total adhesive",
    consumption: "Consumption",
    area: "Area",
    adhesiveDisclaimer: "Estimates are indicative. Actual consumption varies with substrate flatness, tile size and application technique. For project specifications, contact Ashlar Connect.",
    viewTileAdhesives: "View tile adhesives",
    groutType: "Grout type",
    tileLength: "Tile length (mm)",
    tileWidth: "Tile width (mm)",
    tileThickness: "Tile thickness (mm)",
    jointWidth: "Joint width (mm)",
    totalTiledArea: "Total tiled area",
    reset: "Reset",
    totalGrout: "Total grout",
    packsRequired: "Packs required",
    groutDisclaimer: "Grout consumption = ((L + W) / (L × W)) × joint width × tile thickness × density. Estimates are indicative; round up for site conditions.",
    viewGrouts: "View grouts",
    sqft: "sq.ft",
    sqm: "sq.m",
    bag20: "20 kg bag (Tile Adhesive)",
    bag40: "40 kg bag (Block Adhesive)",
    bed3: "3 mm bed · 6 mm notch (small tiles)",
    bed4: "4 mm bed · 8 mm notch (medium)",
    bed5: "5 mm bed · 10 mm notch (large)",
    bed6: "6 mm bed · 12 mm notch (heavy / stone)",
    cementitious: "Cementitious grout (ATG01) — 1 kg pack",
    epoxy: "Epoxy grout (AEG01) — 5 kg / 1 kg kit",
  },
  visualizerPage: {
    eyebrow: "Estimators & Visualizers",
    h1a: "Grout",
    h1b: "Visualiser",
    intro: "Visualise your tile and grout colour combination live — before you order.",
  },
  visualizer: {
    tileLayout: "Tile layout",
    straight: "Straight",
    brick: "Brick",
    subway: "Subway",
    largeFormat: "Large Format",
    tileColour: "Tile colour",
    selected: "Selected",
    groutColour: "Grout colour",
    jointWidth: "Joint width",
    tileSize: "Tile size",
    widthFt: "Width (ft)",
    heightFt: "Height (ft)",
    custom: "Custom",
    reset: "Reset",
    livePreview: "Live preview",
    tile: "Tile",
    grout: "Grout",
    joint: "Joint",
    disclaimer: "Colours shown are on-screen approximations for visualisation only and may vary from the actual product. Sparkle finishes are achieved with Ashlar Epoxy Sparkles (AES01).",
    shopGrouts: "Shop grouts",
    sparkleNote: " · Epoxy Sparkle (AES01)",
    white: "White",
    ivory: "Ivory",
    beige: "Beige",
    grey: "Grey",
    graphite: "Graphite",
    black: "Black",
    marble: "Marble",
    brightWhite: "Bright White",
    silverGrey: "Silver Grey",
    cementGrey: "Cement Grey",
    charcoal: "Charcoal",
    jetBlack: "Jet Black",
    chocolate: "Chocolate",
    sparkleGold: "Sparkle Gold",
    sparkleSilver: "Sparkle Silver",
    sparkleCopper: "Sparkle Copper",
    size1x1: "1 ft × 1 ft",
    size1x15: "1 ft × 1.5 ft",
    size1x2: "1 ft × 2 ft",
    size2x1: "2 ft × 1 ft",
    size2x4: "2 ft × 4 ft",
  },
  careers: {
    eyebrow: "Careers at Ashlar Buildchem · Jaipur, India",
    h1a: "Build your career",
    h1b: "with certified",
    h1c: "certainty.",
    intro: "We engineer high-performance construction chemicals, tile adhesives and surface solutions for modern India. Join an ambitious team where precision chemistry meets manufacturing craftsmanship.",
    exploreOpenings: "Explore Openings",
    applyDirectly: "Submit Application",
    whyJoin: "Why Ashlar",
    whyTitle: "High standards. Real chemistry. Long-term impact.",
    p1Title: "Chemical R&D & Testing",
    p1Body: "Work directly in our state-of-the-art laboratory formulating cutting-edge polymers, cementitious adhesives and technical admixtures.",
    p2Title: "Manufacturing Excellence",
    p2Body: "Experience high-throughput automated dry-mix production lines built to strict ISO 9001:2015 and ISI compliance standards.",
    p3Title: "Rapid Pan-India Growth",
    p3Body: "Fast-track your professional growth as Ashlar expands across distributors, contractors, architects and key infrastructure projects.",
    p4Title: "Merit & Integrity First",
    p4Body: "We reward initiative, technical precision and dedication with fair compensation, leadership opportunities and zero corporate politics.",
    openingsEyebrow: "Current Openings",
    openingsTitle: "Open positions across teams.",
    allDepartments: "All Departments",
    rdQuality: "R&D & Quality",
    salesMarketing: "Sales & Technical",
    operations: "Plant & Operations",
    applyNow: "Apply for this role",
    location: "Location",
    department: "Department",
    type: "Type",
    experience: "Experience",
    urgentBadge: "Urgent Hiring",
    urgentHiringTitle: "Urgent Hiring: Field Sales Executives",
    urgentHiringSubtitle: "Ashlar Buildchem is actively expanding sales operations across Rajasthan. 3 open positions available with immediate joining.",
    preferredLocation: "Preferred Job Location",
    selectLocation: "Select preferred location",
    locJaipur: "Jaipur (1 Vacancy)",
    locSikar: "Sikar (1 Vacancy)",
    locDausa: "Dausa (1 Vacancy)",
    locFlexible: "Any / Flexible (Jaipur, Sikar, Dausa)",
    salaryLabel: "Salary",
    salaryValue: "₹20,000 – ₹30,000 / month",
    fuelLabel: "Fuel Reimbursement",
    fuelValue: "Petrol expenses for official company work only (Home-to-work commute not covered)",
    candidatePreference: "Experience in building materials or construction chemicals sales preferred. Freshers with good communication & sales skills can also apply.",
    vacanciesLabel: "Vacancies",
    formEyebrow: "Job Application",
    formTitle: "Submit your details",
    formSubtitle: "Tell us about your background, experience, and the role you are interested in. All submissions are processed directly by our recruitment desk.",
    fullName: "Full Name",
    namePlaceholder: "e.g. Rahul Sharma",
    email: "Email Address",
    emailPlaceholder: "rahul@example.com",
    phone: "Phone Number",
    roleApplied: "Position Applied For",
    selectRole: "Select a position",
    generalRole: "Open / General Application",
    totalExperience: "Total Experience",
    selectExperience: "Select experience range",
    expFresher: "Fresher / Entry Level",
    exp1to3: "1 - 3 Years",
    exp3to5: "3 - 5 Years",
    exp5plus: "5+ Years",
    currentCompany: "Current Company / College",
    currentCompanyPlaceholder: "e.g. Current Employer or University",
    noticePeriod: "Notice Period",
    selectNotice: "Select notice period",
    noticeImmediate: "Immediate Joining",
    notice15: "15 Days",
    notice30: "30 Days",
    notice60: "60+ Days",
    portfolioUrl: "Resume Link / LinkedIn URL",
    portfolioPlaceholder: "https://drive.google.com/... or linkedin.com/in/...",
    uploadResumeLabel: "Resume / CV Document",
    uploadResumeSubtext: "Upload .pdf or .docx (Max 10MB)",
    dragOrBrowse: "Choose or drag your resume (.pdf or .docx, Max 10MB)",
    selectedFile: "Selected document",
    removeFile: "Remove file",
    orSwitchToUrl: "Or paste LinkedIn profile / Drive link instead",
    orSwitchToFile: "Switch to document upload (.pdf / .docx)",
    fileReadyToUpload: "File will be uploaded upon submitting application",
    fileSizeError: "File size exceeds 10MB limit. Please upload a smaller file.",
    fileTypeError: "Only .pdf and .docx documents are accepted.",
    statement: "Cover Note / Why Ashlar?",
    statementPlaceholder: "Briefly tell us about your sales achievements, experience in building materials/construction chemicals, and why you want to join Ashlar Buildchem...",
    submitApplication: "Submit Application",
    submitting: "Submitting application…",
    uploadingAndSubmitting: "Uploading document & submitting…",
    successMsg: "Your application has been successfully submitted! Our HR team will review your profile and reach out.",
    errRequired: "Please fill in all mandatory fields before submitting.",
    errName: "Please enter a valid full name (letters and spaces only).",
    errPhone: "Please enter a valid 10-digit mobile number.",
    errEmail: "Please enter a valid email address.",
    hrHelp: "Direct HR Desk",
    hrEmail: "hr@ashlarbuildchem.com",
    officeTitle: "Head Office & Laboratory",
    processTitle: "Our Hiring Process",
    step1: "01. Application Review",
    step1Desc: "Detailed evaluation of your background and technical profile.",
    step2: "02. Technical Discussion",
    step2Desc: "Interactive technical round with department leaders.",
    step3: "03. Plant / Office Visit",
    step3Desc: "Tour our facility and meet your future team.",
    step4: "04. Offer & Onboarding",
    step4Desc: "Transparent offer with swift onboarding support.",
  },
  common: {
    loading: "Loading…",
  },
};

export default en;
